import { FluxStandardAction } from "__utils/type";
import * as Actions from "constants/actions";

export const setNFOappliedFilterList = (filterList: any): FluxStandardAction => {
    return {
        type: Actions.SET_NFO_APPLIED_FILTER_LIST,
        payload: filterList
    }
};
export const setNFOappliedSortOption = (sortOpt: any): FluxStandardAction => {
    return {
        type: Actions.SET_NFO_APPLIED_SORT_LIST,
        payload: sortOpt
    }
};